import { useParams } from 'react-router-dom'
import { ButtonSecondary } from '../../../../../../baseComponents/Button'
import { SwitchButton, TabItems } from '../../../../../../baseComponents/Button/SwitchButton'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import PermissionChecker from '../../../../../../baseComponents/PermissionChecker'
import { CustomRenderString } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import useEditDeleteModal from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalUpdateProductAddons from '../ModalUpdateProductAddons'

interface RightHeaderProductAddonBaseProps extends ModalEditComponentProps {
    urlGetData: string
    url: string
    field: string
    children?: React.ReactNode
}

const RightHeaderProductAddonBase: React.FC<RightHeaderProductAddonBaseProps> = ({children, userPermissions, onSubmit, basicData, ...rest}) => {
    const { id } = useParams()
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
         <div className='flex flex-auto items-center justify-between'>
            {children}
            <PermissionChecker userPermissions={userPermissions || false} permission={'update'} >
                <ButtonSecondary className='mr-10' onClick={() => setOpenModal({ type: 'edit', allRowData: { id } })}><TwinTrans transKey='updateRelations'>Editar relaciones</TwinTrans></ButtonSecondary>
                {openModal?.type === 'edit' ? <ModalUpdateProductAddons  {...rest} onSubmit={onSubmit} setOpened={() => setOpenModal(null)} userPermissions={userPermissions} allRowData={{ id, productName: basicData?.name }} /> : null}
            </PermissionChecker >
        </div>
    )
}

const RightHeaderProductAddonSelector: React.FC<RightHeaderProductAddonBaseProps> = ({ basicData, ...rest}) => {

    const items: TabItems[] = [
        {
            element: <TwinTrans transKey={'addonsSell'}>Complementos de venta</TwinTrans>
        },
        {
            element: <TwinTrans transKey={'addonsBuy'}>Complementos de compra</TwinTrans>
        },
    ]
    return (
        <RightHeaderProductAddonBase {...rest} basicData={basicData}>
            <SwitchButton className='mr-auto' onClick={(val) => basicData?.setTypeProductAddon(val as any)} active={basicData?.typeProductAddon} items={items} />
        </RightHeaderProductAddonBase>
    )
}


interface RightHeaderProductAddonSelectorSellProps extends ModalEditComponentProps {}

export const RightHeaderProductAddonSelectorSell: React.FC<RightHeaderProductAddonSelectorSellProps> = ({ basicData, userPermissions, onSubmit, setOpened}) => {
    return (<RightHeaderProductAddonSelector urlGetData='/api/app/product/productAddon/getAllProductAddonsComplete' url='/api/app/product/productAddon/bulkUpdateProductAddons' field='ProductAddonRel.ProductId' {...{ basicData, userPermissions, onSubmit, setOpened }} />)
}

interface RightHeaderProductAddonSelectorBuyProps extends ModalEditComponentProps {}

export const RightHeaderProductAddonSelectorBuy: React.FC<RightHeaderProductAddonSelectorBuyProps> = ({ basicData, userPermissions, onSubmit, setOpened}) => {
    return (<RightHeaderProductAddonSelector urlGetData='/api/app/product/productAddonBuy/getAllProductAddonsBuyComplete' url='/api/app/product/productAddonBuy/bulkUpdateProductAddonsBuy' field='ProductAddonBuyRel.ProductId' {...{ basicData, userPermissions, onSubmit, setOpened }} />)
}


interface RightHeaderTitleProductAddonBaseProps extends ModalEditComponentProps {}

export const RightHeaderTitleProductAddonSell: React.FC<RightHeaderTitleProductAddonBaseProps> = ({ basicData, userPermissions, onSubmit, setOpened }) => {
    const {t} = useTwinTranslation()
    return (
        <RightHeaderProductAddonBase urlGetData='/api/app/product/productAddon/getAllProductAddonsComplete' url='/api/app/product/productAddon/bulkUpdateProductAddons' field='ProductAddonRel.ProductId' basicData={basicData} {...{ userPermissions, onSubmit, setOpened }}>
            <CustomRenderString className='regular18 mr-auto' value={t('addonsSells', 'Complementos de venta')} />
        </RightHeaderProductAddonBase>
    )
}

export const RightHeaderTitleProductAddonBuy: React.FC<RightHeaderTitleProductAddonBaseProps> = ({ basicData, userPermissions, onSubmit, setOpened }) => {
    const {t} = useTwinTranslation()
    return (
        <RightHeaderProductAddonBase urlGetData='/api/app/product/productAddonBuy/getAllProductAddonsBuyComplete' url='/api/app/product/productAddonBuy/bulkUpdateProductAddonsBuy' field='ProductAddonBuyRel.ProductId' basicData={basicData} {...{ userPermissions, onSubmit, setOpened }}>
            <CustomRenderString className='regular18 mr-auto' value={t('addonsBuys', 'Complementos de compra')} />
        </RightHeaderProductAddonBase>
    )
}

export const RightHeaderTitleProductAddonUnify: React.FC<RightHeaderTitleProductAddonBaseProps> = ({ basicData, userPermissions, onSubmit, setOpened }) => {
    const {t} = useTwinTranslation()
    return(
        <RightHeaderProductAddonBase urlGetData='/api/app/product/productAddon/getAllProductAddonsComplete' url='/api/app/product/productAddon/bulkUpdateProductAddons' field='ProductAddonRel.ProductId' basicData={basicData} {...{ userPermissions, onSubmit, setOpened }}>
            <CustomRenderString className='regular18 mr-auto' value={t('addons', 'Complementos')} />
        </RightHeaderProductAddonBase>
    )
}